
import { Link } from "react-router-dom";

import AkkhorLayout from "../layout/akkhor";
import Moment from "react-moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import ListToTrinh from "./ListToTrinh";
import { checkRole } from "../model";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";

export default function DanhSachToTrinh() {
    const [params, setParam] = useState("status=1");
    const [filterShow, setFilterShow] = useState(true)
    const [status, setStatus] = useState(1)
    const [code, setCode] = useState("")
    const [title, setTitle] = useState("")
    const { user } = useSelector((state) => state.auth);
    const idrole = 'workflow_walking'
    const allowDelete = checkRole(user, idrole, 'delete');


    const columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề", options: { filter: true, sort: true } },
        { name: "code", label: "Số Ttr", options: { filter: true, sort: true } },
        {
            name: "author_name", label: "Người tạo", options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="w-100">
                        <strong>{value}</strong><br />
                        <span className="far fa-clock"></span> {<Moment format="DD/MM/YYYY">{new Date(tableMeta.datecreate * 1000)}</Moment>}
                    </div>
                }
            }
        },
        {
            name: "workflow_steps", label: "Tiến trình",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value) {
                        let groupedList = groupStepsByPosition(value || []);
                        let current_pos = tableMeta.position
                        let wf_status = tableMeta.status
                        return <div className="list-tientrinh">
                            <div className="row">
                                {groupedList.map((group) => {
                                    return (
                                        <div className="col-12 col-sm-6 mb-2 item-totrinh" key={group.position}>
                                            <div className="wrapper bg-white border rounded shaddow">
                                                <h5 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
                                                    {group.position}. {group.group_name}
                                                </h5>
                                                <div className="w-100 pl-2 pr-2 pt-2 pb-2 info">
                                                    {group.member.map((m) => (
                                                        <div className="item-user" key={m.id}>
                                                            <div className="user-status" >
                                                                <div className={(group.position == current_pos && m.action != 1 && wf_status == 1) ? "bg-success text-white pl-2 pr-2 pt-1 pb-1" : ""}>
                                                                    <strong>{m.fullname}</strong>

                                                                    {(group.position == current_pos && m.action != 1 && wf_status == 1 && user.data.id == m.user_id) ? <span className="ml-2 fas fa-flag-checkered"></span> : ""}
                                                                </div>
                                                                {(tableMeta.status != 4 || m.action == 4) &&
                                                                    <div className="check_status">
                                                                        {m.action == 1 && (
                                                                            <p className="text-success">
                                                                                <span className="fas fa-check-circle"></span>
                                                                                <i className="ml-1"> Đã duyệt</i>

                                                                            </p>
                                                                        )}
                                                                        {m.action == 2 && (
                                                                            <p className="text-info">
                                                                                <span className="fas fa-times-circle"></span>
                                                                                <i className="ml-1"> Yêu cầu bổ sung</i>
                                                                            </p>
                                                                        )}
                                                                        {m.action == 3 && (
                                                                            <p className="text-danger">
                                                                                <span className="fas fa-times-circle"></span>
                                                                                <i className="ml-1"> Trả về</i>
                                                                            </p>
                                                                        )}
                                                                        {m.action == 4 && (
                                                                            <p className="text-danger">
                                                                                <span className="fas fa-times-circle"></span>
                                                                                <i className="ml-1"> Hủy bỏ</i>
                                                                            </p>
                                                                        )}
                                                                        {m.action == 0 && (
                                                                            <p className="text-warning">
                                                                                <span className="fas fa-clock"></span>
                                                                                <i className="ml-1"> Chờ ký</i>
                                                                            </p>
                                                                        )}
                                                                        {m.timecheck && <small><span className="far fa-clock"></span><Moment format="H:mm DD/MM/YYYY">{m.timecheck}</Moment></small>}
                                                                    </div>
                                                                }
                                                            </div>
                                                            {m.note_comment &&
                                                                <div className="w-100">
                                                                    <i className="far fa-comment-dots"></i><small> {m.note_comment}</small>
                                                                </div>
                                                            }
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    }
                }
            }
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) return <span className="text-info">Chưa hoàn tất</span>
                    if (value == 2) return <span className="text-success">Đã được duyệt</span>
                    if (value == 4) return <span className="text-danger">Đã bị hủy</span>
                }
            }
        },
        {
            name: "action", label: "Thao tác",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let view = null
                    let del = null
                    if (tableMeta.status == 2) {
                        view = <div className="col-6 col-sm-12"><a className="btn btn-sm btn-warning text-white w-100 mt-1" href={"/ho-so-truc-tuyen/" + tableMeta.hash_code}>
                            <span className="fas fa-eye"></span> Xem
                        </a></div>
                    } else {
                        if (tableMeta.author_id == user.data.id) {
                            view = <div className="col-6 col-sm-12"><a className="btn btn-sm btn-warning text-white w-100 mt-1" href={"/edit-workflow_walking/" + tableMeta.id}>
                                <span className="fas fa-eye"></span> Sửa
                            </a></div>
                        } else {
                            view = <div className="col-6 col-sm-12"><a className="btn btn-sm btn-warning text-white w-100 mt-1" href={"/edit-workflow_walking/" + tableMeta.id}>
                                <span className="fas fa-eye"></span> Xem
                            </a></div>
                        }
                        if (allowDelete) {
                            del = <div className="col-6 col-sm-12"><button className="btn btn-sm btn-danger text-white w-100 mt-1" type="button" onClick={() => onDelete(tableMeta.id)}>
                                <span className="fas fa-trash-alt"></span> Xóa
                            </button></div>
                        }
                    }
                    return <div className="row justify-content-center">{view}{del}</div>
                }
            }
        },
    ];

    const onDelete = (tr_id) => {
        confirmAlert({
            title: "Cảnh báo !!!",
            message: "Bạn đang thực hiện thao tác xóa tờ trình",
            buttons: [
                {
                    label: "Có",
                    onClick: () => {
                        Axios.delete(URL_LIST_ALL + 'crm_workflow_walking/' + tr_id, user.config).then(res => {
                            if (res.data.status === "success") {
                                window.location.reload()
                            } else alert(res.data.message);
                        }).catch(err => console.log(err));
                    },
                },
                { label: "Không" },
            ],
        });
    }

    const groupStepsByPosition = (steps) => {
        const grouped = {};

        steps.forEach(step => {
            const pos = step.position;
            if (!grouped[pos]) {
                grouped[pos] = {
                    step_id: step.id,
                    position: pos,
                    group_name: step.group_name,
                    department_name: step.department_name,
                    timecheck: step.timecheck,
                    member: []
                };
            }
            grouped[pos].member.push({
                id: step.id,
                user_id: step.user_id,
                fullname: step.fullname,
                step_type: step.step_type,
                action: step.action,
                position: pos,
                note_comment: step.note_comment,
                timecheck: step.timecheck
            });
        });
        const sorted = Object.values(grouped).sort((a, b) => a.position - b.position);
        sorted.forEach(g => {
            g.member.sort((a, b) => a.step_type - b.step_type);
        });
        return sorted;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (status && status !== '') _param += "&status=" + status
        if (code && code !== '') _param += "&code=" + code
        setParam(_param);
    };

    return (<AkkhorLayout idrole="workflow_walking">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Tờ trình
                </li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-lg-3 col-12 form-group">
                            <label>Trạng thái phê duyệt</label>
                            <select className="form-select height32" value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value="2">Đã được duyệt</option>
                                <option value="1">Chưa hoàn thành</option>
                                <option value="all">Tất cả</option>
                            </select>
                        </div>
                        <div className="col-lg-3 col-12 form-group">
                            <label>Số tờ trình</label>
                            <input placeholder="Nhập số tờ trình..." type="input" className="form-control" value={code} onChange={(e) => setCode(e.target.value)} />
                        </div>
                        <div className="col-lg-3 col-12 form-group">
                            <label>Tiêu đề</label>
                            <input placeholder="Tìm theo tiêu đề..." type="input" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                        </div>
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn btn-sm btn-warning">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <ListToTrinh name="crm_workflow_walking" idrole={idrole} linkaction="workflow_walking" params={params} title="" defaultLimit={10000} serverSide={true} columns={columns}></ListToTrinh>
    </AkkhorLayout>);
}
